import { render, staticRenderFns } from "./createArticleHolder.vue?vue&type=template&id=d2988c44&scoped=true"
import script from "./createArticleHolder.vue?vue&type=script&lang=js"
export * from "./createArticleHolder.vue?vue&type=script&lang=js"
import style0 from "./createArticleHolder.vue?vue&type=style&index=0&id=d2988c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2988c44",
  null
  
)

export default component.exports